// The internal app portfolio pipeline: one kanban (AppPipeline/global) that
// tracks every community app through its lifecycle (onboarding through live and
// growth). Operator-only — same digital_university/tribed gate as the issue
// board (isBoardOperator in types/Board.ts). Unlike the issue board, cards are
// keyed by communityId: one card per app, no duplicates.

import { BoardStageTone } from "./Board";

// Stage defs reuse the board tone palette so TONE_DOT keeps working.
export interface AppStageDef {
  key: string; // slug: [a-z0-9_]+
  label: string;
  tone?: BoardStageTone;
}

export interface AppCard {
  id: string; // == communityId (doc id)
  communityId: string;
  name: string; // display-name snapshot from seeding; UI prefers live title
  stage: string; // stage key
  position: number; // sparse ordering within a column
  nextAction: string; // the single "what's the next move" line
  notes: string;
  owner: string;
  outreachLeadId?: string; // set when the app converted from an outreach lead
  stageChangedAt: string; // powers the days-in-stage badge
  createdAt: string;
  updatedAt: string;
}

export const DEFAULT_APP_STAGES: AppStageDef[] = [
  { key: "triage", label: "Triage", tone: "neutral" },
  { key: "onboarding", label: "Onboarding", tone: "info" },
  { key: "content", label: "Content", tone: "accent" },
  { key: "store_setup", label: "Store Setup", tone: "info" },
  { key: "in_review", label: "In Review", tone: "warning" },
  { key: "live", label: "Live", tone: "success" },
  { key: "growth", label: "Growth", tone: "success" },
  { key: "paused", label: "Paused", tone: "neutral" },
];

// Stages where sitting still is fine — the stale badge skips these.
export const APP_RESTING_STAGES = ["live", "growth", "paused"];
